<template>
  <div id="contenedor-principal-registroTocas" style="position:relative;">
    <div id="contenedor-encabezados-registroTocas" class="text-left">
      <h1>Registro de Ordenes de Protección</h1>
      <h3 class="text-dark">Registra la Orden de Protección</h3>
      <div class="hr-titulo"></div>      
    </div>
    <div id="contenedor-principal-registroTocas" class="row mt-3">
      <!-- Filtro de Búsqueda -->
      <transition name="fade">
      <div  id="contenedor-filtros-registroTocas" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4 ">      
        <div>
          <div class="area gris-claro">
        <FiltroDeBusqueda 
              :catalogos="catalogos"
              :key="'filtro'+contrenderfiltrosExpedientes"
              :ejecutaLaFuncion="buscarExpediente"
              :elementosAOmitir ="elementosAOmitir"
              :elementosAConservar="elementosAConservar"
              :area="obtenerAreaDeUsuario"
              :datosToca="true"
              :tituloDeBusqueda="'Filtros de búsqueda'"
              :descripcionDeBusqueda="'Ingrese la busqueda de la orden de protección:'"
              :ref="'camposBuscarExpediente'">
        </FiltroDeBusqueda>
          </div>
        </div>             
      </div>
      </transition>
      <!-- Tabla de resultados  -->
      <div class="'col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-8  pt-sm-4 pt-md-4 pt-lg-0 pt-xlg-0" id="TocasEncontradas_div">
        <div class="area areaLocal gris-claro">
          <transition name="fade">
            <div v-if="(expedientes == undefined || expedientes == null || expedientes.length <= 0) && datosToca == null"
             style="background-color:var(--gris-pj); padding: 8px;">
              <div class="d-flex justify-content-center">
                    <i class="fas fa-pencil-alt mr-sm-2" style="font-size: 25px;"></i>
                    <div class="align-content-center">
                      <h5>Orden a encontrar</h5>
                    </div>
                </div>
            </div>
          </transition>
            <TablaDeResultados
              v-if="expedientes"
              :expedienteToca="expedientes"
              
              @registrarRelacionExpediente="registrarRelacionExpediente"
              @esPleno="esPleno">
              
            </TablaDeResultados>
            <FiltroDeBusqueda 
              v-if="datosToca && juzgadoExterno == false"
              :catalogos="catalogos"
                  :key="'filtro'+contrenderfiltrosExpedientes"
                  :ejecutaLaFuncion="guardarRelacionTocaExpediente"
                  :elementosAOmitir ="elementosAOmitir"
                  :area="null"
                  :esOrdenDeProteccion="esOrdenDeProteccion"
                  :datosToca="true"
                  :tituloDeBusqueda="'Filtros de búsqueda'"
                  :descripcionDeBusqueda="'Ingrese los datos de la orden: ' + this.datosToca[0].TipoDocumento.Nombre + ' ' + this.datosToca[0].Consecutivo
              + (this.datosToca[0].TipoDocumento.TipoDocumentoId == 1) ? ' ' : ' #' + this.datosToca[0].NumeroDeDocumentoTexto "
                  :ref="'camposOrdenProteccion'">
                  
            </FiltroDeBusqueda>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from "@/../static/js/comun"
  import api from '@/../static/js/api'
  import axios from 'axios'

  import FiltroDeBusqueda from '../Comun/FiltrosDeBusqueda.vue'
  import TablaDeResultados from '../Comun/TablaDeResultados.vue'

  export default{
    data(){
      return{
        enumeraciones,
        catalogos: [          
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo' },   
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda_NoExtra' },       
         
        ],

        elementosAOmitir: {
          areas:[
            20,21,25,26,27,36,39,40,45,61,103,104,106,107,108,112,111,41,105,
            68,44,37,110,109,88,43,85,87,114,116],
          // 11,13,14,15,16 // se quitaron los juzgados penales de elementos a omitir
          materias: [1,2,3,5,6,7,8,9,10,11,12,13],
          tiposDocumento: [3,4,5,6,7,8,9,11,12,13,14,15,16,17,18,19,20,21,22,25,26,29,30,31,32,34,36,37],
      
        },

        elementosAConservar:{
          //partidosJudiciales: [1],
          areas: [9, 10, 22, 34, 57, 86, 18, 17, 24, 29],
          materias: [4],
          tiposDocumento: [1,10],
          // ,30,31 // se comenta por nueva sala que va llevar esos tipos de documento 
        },

        contrenderfiltrosExpedientes: 0,
        actualizarArea: false,
        Tocas: null,
        datosToca: null,
        areaId: null,
        expedienteToca: null,
        juzgadoExterno: false,
        pleno: false,

        expedientes: null,
        esOrdenDeProteccion: false,
      }

    },

    computed:{
      // elementosAConservar : function() //usar solo si es fijo
      // {
      //   let ep = {
      //      partidosJudiciales: [1],  
      //      tiposDocumento: [1,5],
      //      areas: [12,95],
      //      materias: [6],
      //      entidades: [1],
      //   }
      //   return ep;
      // },
      /**
       * Funcion encargadas de obtener area del usuario de store.
       */
      obtenerAreaDeUsuario() {
          return this.$store.getters.Get_AreaDelUsuario;
        }
    },


    watch: {
        '$store.getters.Get_AreaDelUsuario': function() {
            
            //console.log("entro en watch", this.$store.getters.Get_AreaDelUsuario);
            if(!this.actualizarArea){
              if(this.$store.getters.Get_AreaDelUsuario==null || this.$store.getters.Get_AreaDelUsuario==undefined 
                ){
                this.actualizarArea= true;
              }
              this.contrenderfiltrosExpedientes++;

            }
        }
    },


   
    components:{
      FiltroDeBusqueda,
      TablaDeResultados
    },
    methods:{

      buscarTocaSinRelacionAExpediente: function(){
        this.limpiarTablaResultados();

        const parametros = {
          PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['camposBuscarTocas'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['camposBuscarTocas'].parametros_PartidoJudicial.partidoJudicialId : null,
              MateriaId: this.campoRequeridoEsValido(this.$refs['camposBuscarTocas'].parametros_Materia.materiaId) ? this.$refs['camposBuscarTocas'].parametros_Materia.materiaId : null,
              AreaId: this.campoRequeridoEsValido(this.$refs['camposBuscarTocas'].parametros_Area.areaId) ? this.$refs['camposBuscarTocas'].parametros_Area.areaId : null,
              TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs['camposBuscarTocas'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['camposBuscarTocas'].parametros_TipoDocumento.tipoDocumentoId : null,
              Consecutivo: this.campoRequeridoEsValido(this.$refs['camposBuscarTocas'].consecutivo) ? this.$refs['camposBuscarTocas'].consecutivo : null,

        }
        if(this.validarDatosBusquedaTocas(parametros)){
          comun.SeEstaCargandoInformacion(true); 
              const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false); 

              axios.post(api.conexion + api.SITA.sistema.administracion.tocas.BuscarTocas, 
                  parametros, headerPeticion)
                .then(respuesta => {
                comun.SeEstaCargandoInformacion(false);
                if(respuesta.data.SiHayError){
                    console.log(respuesta);
              
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } 
                else{
                  this.areaId = parametros.AreaId;
                    this.Tocas = respuesta.data.Tocas;
                    //this.contRenderTocas += 5;
                    //comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                }         
                })
                .catch(e => {
                  comun.SeEstaCargandoInformacion(false);
                  console.log("No Hay Respuesta del Servidor" + e);
                  comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                });
            }
      },

      registrarRelacionExpediente:function(Toca){
        this.limpiarTablaResultados()
        this.esOrdenDeProteccion = true;
        this.juzgadoExterno = false;
        if((this.$store.getters.Get_AreaDelUsuario!= undefined && this.$store.getters.Get_AreaDelUsuario!= null) &&this.$store.getters.Get_AreaDelUsuario.AreaId==37){
        this.pleno = true;
        }
        else{
          this.pleno = false;
        }
        this.contrenderfiltrosExpedientes+=4;
        this.datosToca = []
        this.datosToca[0] = Toca
      },

      buscarExpediente:function(){
        const parametros = {
          PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['camposBuscarExpediente'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['camposBuscarExpediente'].parametros_PartidoJudicial.partidoJudicialId : null,
              MateriaId: this.campoRequeridoEsValido(this.$refs['camposBuscarExpediente'].parametros_Materia.materiaId) ? this.$refs['camposBuscarExpediente'].parametros_Materia.materiaId : null,
              AreaId: this.campoRequeridoEsValido(this.$refs['camposBuscarExpediente'].parametros_Area.areaId) ? this.$refs['camposBuscarExpediente'].parametros_Area.areaId : null,
              TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs['camposBuscarExpediente'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['camposBuscarExpediente'].parametros_TipoDocumento.tipoDocumentoId : null,
              Consecutivo: this.campoRequeridoEsValido(this.$refs['camposBuscarExpediente'].consecutivo) ? this.$refs['camposBuscarExpediente'].consecutivo : null,
              NumeroRomano: this.campoRequeridoEsValido(this.$refs['camposBuscarExpediente'].numeroRomano) ? this.$refs['camposBuscarExpediente'].numeroRomano : null,
              NumeroExtra: this.campoRequeridoEsValido(this.$refs['camposBuscarExpediente'].numeroExtra) ? this.$refs['camposBuscarExpediente'].numeroExtra : null,
        }
        if((parametros.MateriaId == 9) //oralpenal majat
          && (parametros.AreaId == 48 //oral pabellon
          || parametros.AreaId == 51 //oral jesus maria
          || parametros.AreaId == 52 //oral rincon
          || parametros.AreaId == 53 //oral calvillo
          )){
          parametros.MateriaId = 6 //penal porque en majat no los encuentra
        }
        if(this.validarDatosBusquedaExpediente(parametros)){
          comun.SeEstaCargandoInformacion(true); 
              const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false); 

              axios.post(api.conexion + api.REGOP.sistema.administracion.ordenesdeproteccion.BuscarOrdendeProteccion, 
                  parametros, headerPeticion)
                .then(respuesta => {
                comun.SeEstaCargandoInformacion(false);
                if(respuesta.data.SiHayError){
                    console.log(respuesta);
              
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    this.expedientes = null;
                } 
                else{
                  //this.areaId = parametros.AreaId;
                    this.expedientes = respuesta.data.expedientes;
                    //this.contRenderTocas += 5;
                    //this.contrenderfiltrosExpedientes +=6; // para limpiar o no filtros
                    //comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                }         
                })
                .catch(e => {
                  comun.SeEstaCargandoInformacion(false);
                  console.log("No Hay Respuesta del Servidor" + e);
                  comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                });
            }
      },

      guardarRelacionTocaExpediente:function(datosToca, expedienteToca){

        var relacionar = this;
        console.log(relacionar);

        // if((relacionar.datosToca[0].Materia.MateriaId == 6) //penal majat //probablemente se agregue oral ags
        //   && (relacionar.datosToca[0].Area.AreaId == 48 //oral pabellon
        //   || relacionar.datosToca[0].Area.AreaId == 51 //oral jesus maria
        //   || relacionar.datosToca[0].Area.AreaId == 52 //oral rincon
        //   || relacionar.datosToca[0].Area.AreaId == 53 //oral calvillo
        //     )){
        //   relacionar.datosToca[0].Materia.MateriaId = 9 //a oral penal
        //   relacionar.datosToca[0].Materia.Nombre = "Oral Penal"
        // }
        // if(relacionar.datosToca[0].Area.AreaId == 87){ //segunda instancia
        //   relacionar.datosToca[0].Materia.MateriaId = 9;//oral penal si es segunda instancia
        //   relacionar.datosToca[0].Area.AreaId = 27
        // }
        // if(relacionar.datosToca[0].Area.AreaId == 114){ //sala adole y ejec
        //   relacionar.datosToca[0].Materia.MateriaId = 9;
        // }
        // if(relacionar.datosToca[0].Materia.MateriaId == 4 && relacionar.datosToca[0].Area.AreaId != 37) { // familiar
        //   relacionar.datosToca[0].Area.AreaId = 116//sala familiar
        // }
        // if(relacionar.datosToca[0].Area.AreaId == 19 || relacionar.datosToca[0].Area.AreaId == 44){ // supremo tribunal
        //   relacionar.datosToca[0].TipoDocumento.TipoDocumentoId = (relacionar.datosToca[0].Area.AreaId == 19) ?  32 : 34; 
        //   relacionar.datosToca[0].TipoDocumento.Nombre += (relacionar.datosToca[0].Area.AreaId == 19) ?  ' ADOLESCENTES' : ' EJECUCIÓN';
        //   relacionar.datosToca[0].PartidoJudicial.PartidoJudicialId=1; 
        //   relacionar.datosToca[0].Area.AreaId = 114;
        // }

        if(this.pleno){
          //datosToca.Area.AreaId = 37 //sec de acuaredos
        }

        const parametros = {
          OrdendeProteccion:{
            PartidoJudicialId: this.campoRequeridoEsValido(relacionar.datosToca[0].PartidoJudicial.PartidoJudicialId) ? relacionar.datosToca[0].PartidoJudicial.PartidoJudicialId : null,
            AreaId: this.campoRequeridoEsValido(relacionar.datosToca[0].Area.AreaId) ? relacionar.datosToca[0].Area.AreaId : null,
            MateriaId: this.campoRequeridoEsValido(relacionar.datosToca[0].Materia.MateriaId) ? relacionar.datosToca[0].Materia.MateriaId : null,
            TipoDocumentoId: this.campoRequeridoEsValido(relacionar.datosToca[0].TipoDocumento.TipoDocumentoId) ? relacionar.datosToca[0].TipoDocumento.TipoDocumentoId : null,
            Consecutivo: this.campoRequeridoEsValido(relacionar.datosToca[0].Consecutivo) ? relacionar.datosToca[0].Consecutivo : null,
            DocumentoPadreIdReferencia: this.campoRequeridoEsValido(relacionar.datosToca[0].DocumentoPadreIdReferencia) ? relacionar.datosToca[0].DocumentoPadreIdReferencia : null,
            BaseDeDatosId: this.campoRequeridoEsValido(relacionar.datosToca[0].BaseDatosId) ? relacionar.datosToca[0].BaseDatosId : null,
            NumeroDeDocumento: this.campoRequeridoEsValido(relacionar.datosToca[0].NumeroDeDocumentoTexto) ? parseInt(relacionar.datosToca[0].NumeroDeDocumentoTexto) : null,
            FechaDeRegistroEQUITAS: this.campoRequeridoEsValido(relacionar.datosToca[0].FechadeRegistro) ? relacionar.datosToca[0].FechadeRegistro : null,
            Motivo: this.campoRequeridoEsValido(this.$refs['camposOrdenProteccion'].motivo) ? this.$refs['camposOrdenProteccion'].motivo : null,
            FechaInicio: this.campoRequeridoEsValido(this.$refs['camposOrdenProteccion'].fechaInicio) ? this.$refs['camposOrdenProteccion'].fechaInicio : null,
            FechaFin: this.campoRequeridoEsValido(this.$refs['camposOrdenProteccion'].fechaFin) ? this.$refs['camposOrdenProteccion'].fechaFin : null,
            TipoDependenciaId: this.campoRequeridoEsValido(this.$refs['camposOrdenProteccion'].parametros_Dependencia.dependenciaId) ? this.$refs['camposOrdenProteccion'].parametros_Dependencia.dependenciaId : null,
            TipoEnvioId: this.campoRequeridoEsValido(this.$refs['camposOrdenProteccion'].parametros_TipoEnvio.tipoEnvioId) ? this.$refs['camposOrdenProteccion'].parametros_TipoEnvio.tipoEnvioId : null,
            CorreoEnvia: this.campoRequeridoEsValido(this.$refs['camposOrdenProteccion'].correoEnvia) ? this.$refs['camposOrdenProteccion'].correoEnvia : null,
            CorreoRecibe: this.campoRequeridoEsValido(this.$refs['camposOrdenProteccion'].correoRecibe) ? this.$refs['camposOrdenProteccion'].correoRecibe : null,
          }
        }
        if(this.validarDatosOrdenProteccion(parametros.OrdendeProteccion)){    
          console.log(parametros);                                                                   
          bootbox.dialog({
            title: "Mensaje del sistema",
            message: "¿Desea registrar la orden de proteccion de " + relacionar.datosToca[0].TipoDocumento.Nombre + " " + relacionar.datosToca[0].Consecutivo
              + ((this.datosToca[0].TipoDocumento.TipoDocumentoId == 1) ? ' ' : ' #')  + relacionar.datosToca[0].NumeroDeDocumentoTexto  
              + "<br><br> Al presionar Si ya no se podra hacer ninguna modificación",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + "No",
                className: 'btn-danger float-right',
                        callback: function(){

                        }
              },
              confirm:{
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + "Sí",
                      className: 'btn-success',
                      callback: function(){
                        comun.SeEstaCargandoInformacion(true);

                        const headerPeticion = comun.CrearElHeaderDeAutorizacion(relacionar.$store.state.Login_AutorizacionOriginal, false); 
                        axios.post(api.conexion + api.REGOP.sistema.administracion.ordenesdeproteccion.AltaOrdendeProteccion, parametros, headerPeticion)
                        .then(respuesta =>{
                          comun.SeEstaCargandoInformacion(false);
                          if(respuesta.data.SiHayError) {
                                  console.log(respuesta);
                                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                                }
                                else{
                                  relacionar.$refs['camposBuscarExpediente'].consecutivo = "";
                                  comun.mensajeDeAlerta('Orden de Protección Guardada Correctamente. ' + " " /*+ respuesta.data.Satisfactorio*/, null, null);
                                  relacionar.limpiarTablaResultados();
                                  relacionar.expedientes = null;
                                }
                        })
                        .catch(e => {
                              comun.SeEstaCargandoInformacion(false);
                              console.log("No Hay Respuesta del Servidor" + e);
                              comun.mensajeDeAlerta(comun.mensajeDeError(relacionar.enumeraciones.error.E500), null, null);
                          });
                      }
              }
            }
          })
        }

      },
      guardarExpedienteJuzgadoExterno: function(datosToca){
        var relacionar = this;
        datosToca = this.datosToca[0]
        if(this.pleno){
          //datosToca.Area.AreaId = 37 //sec de acuaredos
        }
        if(datosToca.Area.AreaId == 87){ //segunda instancia
          datosToca.Materia.MateriaId = 9;//oral penal si es segunda instancia
          datosToca.Area.AreaId = 27
        }
        if(datosToca.Area.AreaId == 114){ //sala adole y ejec
          datosToca.Materia.MateriaId = 9;
        }
        if(datosToca.Materia.MateriaId == 4) { // familiar
          console.log('familiar')
          datosToca.Area.AreaId = 116//sala familiar
        }

        const parametros = {
          Toca :{
            PartidoJudicialId: this.campoRequeridoEsValido(datosToca.PartidoJudicial.PartidoJudicialId) ? datosToca.PartidoJudicial.PartidoJudicialId : null,
            AreaId: this.campoRequeridoEsValido(datosToca.Area.AreaId) ? datosToca.Area.AreaId : null,
            MateriaId: this.campoRequeridoEsValido(datosToca.Materia.MateriaId) ? datosToca.Materia.MateriaId : null,
            TipoDocumentoId: this.campoRequeridoEsValido(datosToca.TipoDocumento.TipoDocumentoId) ? datosToca.TipoDocumento.TipoDocumentoId : null,
            Consecutivo: this.campoRequeridoEsValido(datosToca.Consecutivo) ? datosToca.Consecutivo : null,
            DocumentoPadreIdReferencia: this.campoRequeridoEsValido(datosToca.DocumentoPadreIdReferencia) ? datosToca.DocumentoPadreIdReferencia : null,
            BaseDatosId: this.campoRequeridoEsValido(datosToca.BaseDatosId) ? datosToca.BaseDatosId : null,
            Pleno: this.pleno,
          },
          ExpedientesAntecedentesTocas:{
            PartidoJudicialId: 1, // 1 si es externo
            AreaId: 89, //externo
            MateriaId: this.campoRequeridoEsValido(this.$refs['camposGuardarExpedienteExterno'].parametros_Materia.materiaId) ? this.$refs['camposGuardarExpedienteExterno'].parametros_Materia.materiaId : null,
            TipoDocumentoId: this.campoRequeridoEsValido(this.$refs['camposGuardarExpedienteExterno'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['camposGuardarExpedienteExterno'].parametros_TipoDocumento.tipoDocumentoId : null,
            Consecutivo: this.campoRequeridoEsValido(this.$refs['camposGuardarExpedienteExterno'].consecutivo) ? this.$refs['camposGuardarExpedienteExterno'].consecutivo : null,
            DocumentoPadreIdReferencia: null,
            BaseDatosId: null,
            NumeroRomano: this.campoRequeridoEsValido(this.$refs['camposGuardarExpedienteExterno'].numeroRomano) ? this.$refs['camposGuardarExpedienteExterno'].numeroRomano : null,
            JuzgadoExterno: this.campoRequeridoEsValido(this.$refs['camposGuardarExpedienteExterno'].juzgadoExternoNombre) ? this.$refs['camposGuardarExpedienteExterno'].juzgadoExternoNombre : null,
            NumeroDeDocumento: this.campoRequeridoEsValido(this.$refs['camposGuardarExpedienteExterno'].numeroExtra) ? parseInt(this.$refs['camposGuardarExpedienteExterno'].numeroExtra) : null
          }

        }


        bootbox.dialog({
          title: "Mensaje del sistema",
          message: "¿Desea relacionar la " + datosToca.TipoDocumento.Nombre + " " + datosToca.Consecutivo
              + " con el consecutivo " + " " + this.$refs['camposGuardarExpedienteExterno'].consecutivo
              + " del juzgado externo " + this.$refs['camposGuardarExpedienteExterno'].juzgadoExternoNombre
            + "<br><br> Al presionar Si ya no se podra hacer ninguna modificación",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + "No",
              className: 'btn-danger float-right',
                      callback: function(){
                        
                      }
            },
            confirm:{
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + "Sí",
                    className: 'btn-success',
                    callback: function(){
                      comun.SeEstaCargandoInformacion(true);

                      const headerPeticion = comun.CrearElHeaderDeAutorizacion(relacionar.$store.state.Login_AutorizacionOriginal, false); 
                      axios.post(api.conexion + api.REGOP.sistema.administracion.ordenesdeproteccion.AltaOrdendeProteccion, parametros, headerPeticion)
                      .then(respuesta =>{
                        comun.SeEstaCargandoInformacion(false);
                        if(respuesta.data.SiHayError) {
                                console.log(respuesta);
                                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                              }
                              else{
                                relacionar.$refs['camposBuscarTocas'].consecutivo = "";
                                comun.mensajeDeAlerta('Orden de Protección Guardada Correctamente. ' + " " /*+ respuesta.data.Satisfactorio*/, null, null);
                                relacionar.limpiarTablaResultados();
                                relacionar.contrenderfiltrosExpedientes += 6;
                              }
                      })
                      .catch(e => {
                            comun.SeEstaCargandoInformacion(false);
                            console.log("No Hay Respuesta del Servidor" + e);
                            comun.mensajeDeAlerta(comun.mensajeDeError(devolucionCaja.enumeraciones.error.E500), null, null);
                        });
                    }
            }
          }
        })
      },

      limpiarTablaResultados: function(){
        this.Tocas = null;
        this.datosToca = null;
        this.expedienteToca = null;
      },

      limpiarFiltrosJuzgadoExterno: function(juzgadoExterno){
        if(this.$refs['camposGuardarExpedienteExterno']){
          this.$refs['camposGuardarExpedienteExterno'].juzgadoExternoNombre = null;
          
          this.$refs['camposGuardarExpedienteExterno'].parametros_Materia.materiaId = -1;
          this.$refs['camposGuardarExpedienteExterno'].parametros_Materia.parametros.PartidoJudicialId = 1;
          //this.parametros_Materia.parametros.AreaId = -1;
          this.$refs['camposGuardarExpedienteExterno'].parametros_Materia.parametros.MateriaId = -1;
          this.$refs['camposGuardarExpedienteExterno'].parametros_Materia.parametros.TipoDocumentoId = -1;      
          this.$refs['camposGuardarExpedienteExterno'].parametros_Materia.key += 1;

          this.$refs['camposGuardarExpedienteExterno'].parametros_TipoDocumento.parametros.PartidoJudicialId = 1;
          this.$refs['camposGuardarExpedienteExterno'].parametros_TipoDocumento.parametros.AreaId = -1;
          this.$refs['camposGuardarExpedienteExterno'].parametros_TipoDocumento.parametros.MateriaId = -1;  

          this.$refs['camposGuardarExpedienteExterno'].parametros_TipoDocumento.tipoDocumentoId = -1;     
          this.$refs['camposGuardarExpedienteExterno'].parametros_TipoDocumento.key += 1;  

          this.$refs['camposGuardarExpedienteExterno'].consecutivo = null;

        }
        if(this.$refs['camposBuscarExpediente']){

          this.$refs['camposBuscarExpediente'].parametros_Materia.materiaId = -1;
          this.$refs['camposBuscarExpediente'].parametros_Materia.parametros.PartidoJudicialId = 1;
          //this.parametros_Materia.parametros.AreaId = -1;
          this.$refs['camposBuscarExpediente'].parametros_Materia.parametros.MateriaId = -1;
          this.$refs['camposBuscarExpediente'].parametros_Materia.parametros.TipoDocumentoId = -1;      
          this.$refs['camposBuscarExpediente'].parametros_Materia.key += 1;

          this.$refs['camposBuscarExpediente'].parametros_Area.areaId = this.area != null ? this.area.AreaId : -1;
          this.$refs['camposBuscarExpediente'].parametros_Area.parametros.PartidoJudicialId = 1;
          //this.parametros_Area.parametros.AreaId = -1;
          this.$refs['camposBuscarExpediente'].parametros_Area.parametros.MateriaId = -1;
          this.$refs['camposBuscarExpediente'].parametros_Area.key += 1;

          this.$refs['camposBuscarExpediente'].parametros_TipoDocumento.parametros.PartidoJudicialId = 1;
          this.$refs['camposBuscarExpediente'].parametros_TipoDocumento.parametros.AreaId = -1;
          this.$refs['camposBuscarExpediente'].parametros_TipoDocumento.parametros.MateriaId = -1;  

          this.$refs['camposBuscarExpediente'].parametros_TipoDocumento.tipoDocumentoId = -1;     
          this.$refs['camposBuscarExpediente'].parametros_TipoDocumento.key += 1;  

          this.$refs['camposBuscarExpediente'].consecutivo = null;
        }
        this.expedienteToca = null;
        this.juzgadoExterno = juzgadoExterno;
      },
      esPleno: function(pleno){
        this.pleno = pleno
        console.log(this.pleno)
      },
      
        campoRequeridoEsValido: function(campo) {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },

      validarDatosBusquedaTocas: function(datos){
        if(datos.TipoDeDocumentoId == null || datos.TipoDeDocumentoId == -1){
          comun.mensajeDeAlerta("Favor de indicar el tipo de toca", null, null);
            return false;
        }
        if(datos.PartidoJudicialId == null || datos.PartidoJudicialId == -1){
          comun.mensajeDeAlerta("Favor de indicar el partido judicial.", null, null);
          return false;
        }
        // if(datos.MateriaId == null || datos.MateriaId == -1) { 
        //   comun.mensajeDeAlerta("Favor de indicar la materia.", null, null);
        //   return false;
        // }
        if(datos.AreaId == null || datos.AreaId == -1) { 
          comun.mensajeDeAlerta("Favor de indicar el área.", null, null);
          return false;
        }
        if(datos.Consecutivo == null || datos.Consecutivo == -1) { //8/comemntar luego
          comun.mensajeDeAlerta("Favor de indicar el consecutivo de la toca.", null, null);
          return false;
        }
        // if((datos.Consecutivo == null || datos.Consecutivo == -1) && this.datosToca == null) { 
        //   comun.mensajeDeAlerta("Favor de indicar el consecutivo", null, null);
        //   return false;
        // }
        else if(datos.Consecutivo.length < 9){
          comun.mensajeDeAlerta("Favor de indicar el consecutivo completo", null, null);
          return false;
        }
        return true;
      },
      validarDatosOrdenProteccion: function(datos){
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if(datos.TipoDependenciaId == null || datos.TipoDependenciaId == -1){
          comun.mensajeDeAlerta("Favor de indicar la dependencia");
          return false;
        }
        else if(datos.TipoEnvioId == null || datos.TipoEnvioId == -1){
          comun.mensajeDeAlerta("Favor de indicar el tipo de envio");
          return false;
        }
        else if(datos.Motivo == null || datos.Motivo == -1){
          comun.mensajeDeAlerta("Favor de indicar el motivo", null, null);
          return false;
        }
        else if(!emailRegex.test(datos.CorreoEnvia) && datos.CorreoEnvia!=null){
          comun.mensajeDeAlerta("Favor de indicar un correo que envia valido", null, null);
          return false;
        }
        else if(!emailRegex.test(datos.CorreoRecibe) && datos.CorreoRecibe!=null){
          comun.mensajeDeAlerta("Favor de indicar un correo que recibe valido", null, null);
          return false;
        }

        return true;
      },

      validarDatosBusquedaExpediente: function(datos){
        if(datos.TipoDeDocumentoId == null || datos.TipoDeDocumentoId == -1){
          comun.mensajeDeAlerta("Favor de indicar el tipo de documento", null, null);
            return false;
        }
        if(datos.PartidoJudicialId == null || datos.PartidoJudicialId == -1){
          comun.mensajeDeAlerta("Favor de indicar el partido judicial.", null, null);
          return false;
        }
        // if(datos.MateriaId == null || datos.MateriaId == -1  ) { 
        //   comun.mensajeDeAlerta("Favor de indicar la materia.", null, null);
        //   return false;
        // }
        if(datos.AreaId == null || datos.AreaId == -1) { 
          comun.mensajeDeAlerta("Favor de indicar el área.", null, null);
          return false;
        }
        if(datos.Consecutivo == null || datos.Consecutivo == -1) { 
          comun.mensajeDeAlerta("Favor de indicar el consecutivo", null, null);
          return false;
        }
        else if(datos.Consecutivo.length < 9){
          comun.mensajeDeAlerta("Favor de indicar el consecutivo completo", null, null);
          return false;
        }
        return true;
      },
    }
  }

</script>


<style scoped>
  .bloquearDiv{
    pointer-events: none;
  }
  .wrapDivBloqueado
  {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style>

.newSectionFilters .btn-light {
    background-color: green;
    border: 1px solid #4F4949;
    color: #42505c;
    font-size: 1em;
}
.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#0000;
}
.gris-claro{
  background-color: var(--gris-pj-100) !important;
}
.areaLocal{
  background-color: var(--verde-pj-100);
  box-shadow: 0px 6px 20px 4px #161616;
  padding: 25px;
}
.modal-content{
  background-color: var(--verde-pj-100);
  box-shadow: 0px 6px 20px 4px #161616;
}
</style>


// WEBPACK FOOTER //
// src/components/REGOP/Administracion/RegistrodeOrdenes.vue